import React, { useState, useLayoutEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';


import Page from '../layouts/Page';
import services from '../services';

const PrivateRoutes = ({ component: Component, ...rest }) => {
    const [resultadoPesquisar, setResultadoPesquisar] = useState();
    const { IsAdmin } = services.storage.getUser();
    const routers = ['/home', '/configuracoes'];
    const search = (value) => {
        if (value.length > 0) {
            setResultadoPesquisar(value);
        }
    }

    return (
        <div>
            {(IsAdmin == 'False' && routers.includes(rest.path)
                ? (<Redirect to={{ pathname: '/galeria-midia' }} />)
                : (<Route {...rest} render={props => (
                    services.storage.get('isAuthenticated')
                        ? <Page search={search}> <Component {...props} resultadoPesquisar={resultadoPesquisar} />  </Page>
                        : <Redirect to={{ pathname: '/', state: { from: props.location } }} />
                )} />))
            }

        </div>

    )
}

export default PrivateRoutes;